import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import _ from 'lodash';
import { Service } from "../../../../service/service"
import { unAuthorized } from '../../../../auth/Auth.ducks'

// journee actions

export const GET_JOURNEE_PENDING = "GET_JOURNEE_PENDING";
export const GET_JOURNEE_REJECTED = "GET_JOURNEE_REJECTED";
export const GET_JOURNEE_FULFILLED = "GET_JOURNEE_FULFILLED";
export const DELETE_NOTIFICATIONS_PENDING = "DELETE_NOTIFICATIONS_PENDING";
export const DELETE_NOTIFICATIONS_REJECTED = "DELETE_NOTIFICATIONS_REJECTED";
export const DELETE_NOTIFICATIONS_FULFILLED = "DELETE_NOTIFICATIONS_FULFILLED";

export const GET_JOURNEE = "GET_JOURNEE";

const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_JOURNEE_PENDING:
      return true;
    case GET_JOURNEE_REJECTED:
    case GET_JOURNEE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_JOURNEE_PENDING:
    case GET_JOURNEE_FULFILLED:
      return null;
    case GET_JOURNEE_REJECTED:
      return payload;
    default:
      return null;
  }
};
// ficheEnfant.Journee.data
const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_JOURNEE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    case GET_JOURNEE_PENDING:
    case GET_JOURNEE_REJECTED:
      return null;
    default:
      return state;
  }
};

// JOURNEE reducer
export default combineReducers({ loading, error, data });

export const getJournee = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_JOURNEE_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/${id}/agendas/timeline`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })
    response.then((res) => {
      dispatch({ type: GET_JOURNEE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_JOURNEE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const NotificationsDelete = (tok, ids) => {
  return (dispatch) => {
    dispatch({ type: DELETE_NOTIFICATIONS_PENDING })
     const response = Service.deleteOne(`${API}api/creche/notifications`, {  headers: { Authorization: `Bearer ${tok}` } , data:{
      "ids": ids
    }})
     response.then((res) => {
      dispatch({ type: DELETE_NOTIFICATIONS_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
       dispatch({ type: DELETE_NOTIFICATIONS_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
//Mock API

// export const getJournee = (id) => ({
//   type: GET_JOURNEE,
//   payload: axios.get(`${API}api/timeline`)
// });